import { useEffect, useState } from 'react';
import { fetchActiveTrials } from 'pricing-pages-lib/api/fetchActiveTrials';
export const useIsInActiveTrial = () => {
  const [isInActiveTrial, setIsInActiveTrial] = useState(true);
  useEffect(() => {
    fetchActiveTrials().then(activeTrials => {
      if (activeTrials && activeTrials.length > 0) {
        setIsInActiveTrial(true);
      } else setIsInActiveTrial(false);
    }).catch(() => {
      setIsInActiveTrial(true);
    });
  }, []);
  return isInActiveTrial;
};